module.exports = __webpack_public_path__ + "static/media/radiobutton_OFF.fa1d4e1e.svg";